module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-zh-TW.b5471e08.jpg";